<script lang="ts">
  import { pop } from "svelte-spa-router";
  import Separator from "$shared/components/Separator.svelte";
  import { onMount } from "svelte";
  import { Toast } from "$components";
  import { withApi } from "$shared/lib/api-parkito";

  import CardInline from "$shared/components/CardInline.svelte";
  import type {
    Debtor,
    DebtorPaymentMethod,
    MyPagesStart,
  } from "../../../apis/parkito";
  import PaymentMethodEdit from "$shared/components/parkito/debtors/PaymentMethodEdit.svelte";

  // Exported variable with name `params` is set
  // by svelte-spa-router. Check App.svelte
  export let params: { id: string };
  export let myPagesData: SvelteStore<MyPagesStart> | undefined;
  let debtor: Debtor | undefined = undefined;

  onMount(() => {
    if (import.meta.env.DEV) console.log("Mounted payment method terms");
    $myPagesData?.debtors.find((d: any) => {
      if (d.debtor.id === params.id) {
        debtor = d.debtor;
      }
    });
  });

  const submitPaymentMethodForm = async (data: DebtorPaymentMethod) => {
    const res = await withApi((api) => {
      return api.debtorSetPaymentMethod(debtor?.id ?? "", data);
    });
    if (res.isOk()) {
      Toast.info("Betalmetod har uppdaterats");
      window.location.reload();
    }
  };
</script>

<div>
  <div class="px-[24px] py-[24px] max-mobile:px-[8px] max-mobile:py-[8px]">
    <button
      on:click={() => {
        pop();
      }}
      class="-ml-[8px]"
    >
      <img
        src="./icons/arrow-left-small.svg"
        class="w-[24px] inline p-[8px] pb-[11px]"
        alt="arrow-left"
      />
    </button>
    <h2 class="text-[#181818] text-[17px] -mt-[30px] inline relative">
      Betalmetod
    </h2>
  </div>
  <Separator customClass="max-mobile:hidden" />

  <div
    class="w-full min-[840px]:columns-2 columns-1 p-[24px] max-mobile:px-[8px]"
  >
    <CardInline title="Betalmetod">
      {#if debtor && debtor.id}
        <PaymentMethodEdit
          paymentMethod={debtor?.paymentMethod}
          submitForm={submitPaymentMethodForm}
        />
      {/if}
    </CardInline>
  </div>
</div>
